module.exports = __webpack_public_path__ + "static/media/5DPO19.4b125ef0.jpg";